import { Alert, AlertDescription } from '@nesso/ui/primitives/alert';

import { useRequestPasswordReset } from '../lib/use-request-password-reset';
import { RequestPasswordResetForm } from './request-password-reset/request-password-reset-form';
import { RequestPasswordResetSent } from './request-password-reset/request-password-reset-sent';

type Props = {
    // Renders the "link expired" alert above the form; set when the flow is reached from an
    // expired/used reset link (Figma 2438-1208) rather than the standalone forgot-password page.
    expired?: boolean;
};

export function RequestPasswordReset({ expired = false }: Props) {
    const {
        screen,
        submittedEmail,
        email,
        errors,
        isSubmitting,
        setEmail,
        handleEmailBlur,
        handleSubmit,
    } = useRequestPasswordReset();

    if (screen === 'sent') {
        return <RequestPasswordResetSent email={submittedEmail} />;
    }

    return (
        <>
            {expired ? (
                <Alert variant="destructive" className="gap-x-0">
                    <AlertDescription>
                        <div>
                            <span className="font-bold">Link expired.</span> Enter your email to
                            receive a new one
                        </div>
                    </AlertDescription>
                </Alert>
            ) : null}

            <div className="flex flex-col gap-4">
                <h1 className="text-3xl font-bold md:text-4xl">Forgot your password?</h1>
                <p className="text-muted-foreground text-sm">
                    Enter your email address, and we&apos;ll send you instructions to reset your
                    password
                </p>
            </div>

            <RequestPasswordResetForm
                email={email}
                error={errors.email}
                formError={errors.form}
                isSubmitting={isSubmitting}
                setEmail={setEmail}
                onEmailBlur={handleEmailBlur}
                onSubmit={handleSubmit}
            />
        </>
    );
}
